<template>
  <div class="home">
    <b-card no-body class="p-4 rounded-0 shadow-none">
      <v-wait :for="loaderName">
        <template slot="waiting">
          <HalfCircleSpinner />
          <div class="spinner-message my-3 text-center">
            Loading data...
          </div>
        </template>
        <h2
          v-if="content && content.heading"
          class="my-3 v2_font_size_20 v2_color_black"
          v-html="content.heading"
        />
        <div v-if="content && content.p1">
          <accordion :key="'question-' + i" v-for="(questionAnswer, i) in content.p1" :title="questionAnswer.question">
            <p class="v2_font_size_18 v2_color_black" v-html="questionAnswer.answer" />
          </accordion>
        </div>
      </v-wait>
    </b-card>
  </div>
</template>

<script>
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';
import Accordion from "@/components/Accordion";

export default {
  name: 'FAQPage',
  components: {
    HalfCircleSpinner,
    Accordion
  },
  data: function () {
    return {
      content: null,
    };
  },
  computed: {
    loaderName: function () {
      return this.$options.name + '_loading';
    },
  },
  created: async function () {
    this.$wait.start(this.loaderName);
    try {
      this.content = await Api.getFaqDynamicContent();
    } catch {
      this.$toasted.error(
        'Unable to upload page content. Please try again later',
        { duration: 3000 }
      );
    } finally {
      this.$wait.end(this.loaderName);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
